import React from 'react';
import Footer from '../Components/Footers/Footer';
import Header from '../Components/Headers/Header';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripeForm from '../Components/Stripe/StripeForm';
import "../assests/css/Payment.css";
import { Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import img_tick_circle from '../assests/images/Icon-feather.png';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Link } from 'react-router-dom';

const Payment = () => {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // stripe implementation starts

    // stripe implementation ends

    return (
        <div className='payment'>
            <section className='bg-privacy-policy-top mb-3'>
                <Header />
                <div className='container px-5'>
                    <div className='row px-3'>
                        <div className='col-lg-12 my-4 text-center'>
                            <p className='text-white f-72 my-5 f-pop-med'>Payment</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className='payemnt pt-5 pb-5'>
                <div className='container'>
                    <div className='row mb-3'>

                        <div className='col-lg-12'>
                            <p className='f-25 f-pop-med cstm-clr mb-5'>Payment Section</p>
                        </div>

                        <div className='col-lg-7'>
                            <div className='card  h-100'>
                                <div className='card-body crd-payment px-2rem py-5 '>
                                    <p className='f-pop-semibold f-22 mt-5 cstm-clr'>Enter Card Details</p>
                                    <p className='f-14 f-pop-med f-14 my-4 cstm-clr'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temp</p>
                                    <StripeForm handleClickOpen={handleClickOpen} />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-5'>
                            <div className='card h-100'>
                                <div className='card-body crd-payment p-cus-card'>
                                    <p className='f-pop-semibold f-22 six2clr  cstm-clr'>Your Journey</p>
                                    <p className='f-14 f-pop-med f-14 cstm-clr brdr-btm-gr six2clr'>Your Pick up time is 12:00am and Drop off time is 02:30pm please pay amount and get enjoy ride</p>
                                    <p className='mt-3 f-16 f-pop-semibold cstm-clr'>Pickup Address</p>
                                    <p className='f-14 f-pop-med f-14 cstm-clr brdr-btm-gr six2clr'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temp</p>
                                    <p className='mt-3 f-16 f-pop-semibold cstm-clr'>Drop off Address</p>
                                    <p className='f-14 f-pop-med f-14 cstm-clr brdr-btm-gr six2clr'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temp</p>
                                    <div className='d-flex justify-spacebw mt-3'>
                                        <p className='f-pop-semibold f-16 cstm-clr' >Pickup Time</p>
                                        <div className='d-flex'>
                                            <p className='f-pop-semibold f-16 cstm-clr'>18 Feb 2022</p> <p className='f-pop-semibold cstm-clr f-16 ms-3'>12:48</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-lg-12'>
                            <button variant="outlined" color="primary" onClick={handleClickOpen}>
                                Open alert dialog
                            </button>
                        </div> */}

                        <Dialog
                            maxWidth={"md"}
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <div className="payment_modal">
                                <div className='container-fluid modal_payment_dialog'>
                                    <div className='row'>
                                        <div className='col-lg-12 text-end px-0'>
                                            <div className='red_cross_button'>
                                                <FontAwesomeIcon className='' style={{ cursor: "pointer" }} onClick={handleClose} icon={faXmark} />
                                            </div>
                                        </div>
                                        <div className='col-lg-12 mt-4 text-center px-0'>
                                            <CheckCircleOutlineIcon className='mt-3 mb-3' style={{ height: '70px', width: "70px", cursor: "pointer" }} />
                                            {/* <img height={100} width={100} src={img_tick_circle}/> */}
                                            <p className='f-25 f-pop-med mb-4 clr-grnn-dialog-payemnt'>Payment Done</p>
                                            <div className='px-30px'>
                                                <p className='f-14 f-pop-med mb-5 clr-grnn-dialog-payemnt'>Curabitur placerat cursus nisi nec pharetra. Proin quis tortor fringilla, placerat nisi nec, auctor ex. Donec commodo orci ac lectus mattis, sed interdum sem scelerisque.  Curabitur placerat cursus nisi nec pharetra. Proin quis </p>
                                            </div>
                                            <Link to="/" className='link_ourfleet'>
                                                <button className="btn btn-danger bt_payment_dialog f-pop-med f-14 p-3 px-5 mb-5 clr-grnn-dialog-payemnt">Back to homepage</button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            {/* <DialogActions>
                                    <button onClick={handleClose} color="primary">
                                        Disagree
                                    </button>
                                    <button onClick={handleClose} color="primary" autoFocus>
                                        Agree
                                    </button>
                                </DialogActions> */}
                        </Dialog>

                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Payment;